export default __webpack_public_path__ + "004119e782ca7eb7a07970bd6019735a.svg";